import { Home } from 'layouts';
import { HOME_POSTS } from 'lib/graphql/queries/home';
import { GetStaticProps } from 'next';
import { createApolloClient } from '@elevator/ui';
import { HomePosts } from 'types/home';
import { reportError } from 'lib/errors';

const emptyHomePosts: HomePosts = {
  featuredPosts: {} as HomePosts['featuredPosts'],
  publishedPosts: [],
  homepageSettings: { showHero: false, showFeatured: true },
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const client = createApolloClient(process.env.API_URL);

    const { data } = await client.query<HomePosts>({
      query: HOME_POSTS,
      variables: {
        limit: 9,
        skip: 0,
      },
    });

    return {
      props: {
        posts: data,
      },
      revalidate: 600, // 10 minutes
    };
  } catch (err) {
    reportError(err, {
      metaData: {
        operation: 'graphql query homePosts',
        mode: 'getStaticProps',
      },
      severity: 'warning',
    });

    return {
      props: {
        posts: emptyHomePosts,
      },
      revalidate: 600,
    };
  }
};

export default Home;
